module.exports = __webpack_public_path__ + "img/22-1.5b881659.png";